import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { PermissionModel } from 'app/models/permission.model';

@Injectable({
    providedIn: 'root',
})
export class PermissionService extends BaseService<PermissionModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'permission');
    }
}
